import React, { Children, Component } from 'react';
import Arrows from 'atoms/carrousel/arrows';
import Dots from 'atoms/carrousel/dots';
import PropTypes from 'prop-types';


export default class Carrousel extends Component {
  constructor(props) {
    super(props);
    this.swipeInitValue = { x: 0, y: 0 };
    this.indexLastValue = 0;
    this.state = {
      index: 0,
      slowAnimation: true,
    };
  }

  componentDidMount() {
    const { currentSlide } = this.props;
    const { index } = this.state;
    if (currentSlide !== index) {
      this.setSlide(currentSlide);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentSlide, children } = this.props;
    if (currentSlide !== nextProps.currentSlide) {
      this.setSlide(nextProps.currentSlide);
    }

    if (Children.count(children) !== Children.count(nextProps.children)) {
      this.setState({ slowAnimation: false });
    }
  }

  getSlidesNumber() {
    const { children } = this.props;
    return Children.toArray(children).length;
  }

  getSlideWidthPercent() {
    return 100 / this.getSlidesNumber();
  }

  setSlide(i) {
    const { handleSlideChange } = this.props;
    const { index } = this.state;
    if (i === index) return;

    handleSlideChange(i);
    this.setState({ index: i, slowAnimation: true });
  }

  moveSlide(indexOffset, resetValue = 0) {
    const { handleSlideChange } = this.props;
    this.setState((prevState) => {
      const potentialNewIndex = Math.round(prevState.index + indexOffset);
      const shouldResetIndex = potentialNewIndex > this.getSlidesNumber() - 1;
      const newIndex = shouldResetIndex ? resetValue : potentialNewIndex;
      const prevIndex = indexOffset > 0 ? Math.floor(prevState.index) : Math.ceil(prevState.index);

      if (newIndex !== prevIndex) handleSlideChange(newIndex, prevIndex);
      return { index: newIndex, slowAnimation: true };
    });
  }

  nextSlide(e) {
    e.preventDefault();
    const { handleArrowsClick } = this.props;
    handleArrowsClick('right');
    this.moveSlide(1);
  }

  prevSlide(e) {
    e.preventDefault();
    const { handleArrowsClick } = this.props;
    handleArrowsClick('left');
    this.moveSlide(-1);
  }

  handleSwipeStart(event) {
    const { index } = this.state;
    document.ontouchmove = e => e.preventDefault();
    this.swipeInitValue = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    this.indexLastValue = index;
    this.setState({ slowAnimation: false });
  }

  handleSwipeMove(event) {
    const swipeMoveHorizontal = this.swipeInitValue.x - event.touches[0].clientX;
    const swipeMoveVertical = this.swipeInitValue.y - event.touches[0].clientY;
    if (Math.abs(swipeMoveVertical) > Math.abs(swipeMoveHorizontal)) {
      document.ontouchmove = null;
      return null;
    }

    const totalWidth = event.currentTarget.parentNode.getBoundingClientRect().width * this.getSlidesNumber();
    const indexVariation = swipeMoveHorizontal * 100 / totalWidth / this.getSlideWidthPercent();
    const indexNewValue = this.indexLastValue + indexVariation;

    const maxIndex = this.getSlidesNumber() - 1;
    const minIndex = 0;
    if (indexNewValue > maxIndex) return this.setState({ index: maxIndex + 0.05, slowAnimation: true });
    if (indexNewValue < minIndex) return this.setState({ index: minIndex - 0.05, slowAnimation: true });
    return this.setState({ index: indexNewValue });
  }

  handleSwipeEnd() {
    const { index } = this.state;
    document.ontouchmove = null;
    const SWIPE_THRESHOLD_VALUE = 2 / 5;
    const directionSign = index > this.indexLastValue ? 1 : -1;
    const resetValue = this.getSlidesNumber() - 1;

    this.moveSlide(SWIPE_THRESHOLD_VALUE * directionSign, resetValue);
  }

  render() {
    const { arrowsComponent, children, className, establishment, isSwipeEnabled, showArrows, showSpinner } = this.props;
    const numberOfSlides = this.getSlidesNumber();
    const { index, slowAnimation } = this.state;
    const translationValue = index * this.getSlideWidthPercent();
    const containerStyle = {
      MozTransform: `translateX(${translationValue * -1}%)`,
      msTransform: `translateX(${translationValue * -1}%)`,
      OTransform: `translateX(${translationValue * -1}%)`,
      transform: `translateX(${translationValue * -1}%)`,
      WebkitTransform: `translateX(${translationValue * -1}%)`,
      width: `${100 * numberOfSlides}%`,
    };

    const arrowsComp = () => {
      if (!showArrows) return null;
      if (arrowsComponent) return arrowsComponent;
      return (
        <Arrows
          handleLeftArrowClick={ this.prevSlide.bind(this) }
          handleRightArrowClick={ this.nextSlide.bind(this) }
          showLeftArrow={ index > 0 }
          showReloadAtEnd={ numberOfSlides > 1 }
          showRightArrow={ index < numberOfSlides - 1 && numberOfSlides > 1 }
        />
      );
    };
    return (
      <div className={ `carrousel ${className}` }>
        { arrowsComp() }
        <div
          className="carrousel__innocuos-container"
          onTouchEnd={ isSwipeEnabled ? this.handleSwipeEnd.bind(this) : undefined }
          onTouchMove={ isSwipeEnabled ? this.handleSwipeMove.bind(this) : undefined }
          onTouchStart={ isSwipeEnabled ? this.handleSwipeStart.bind(this) : undefined }
        >
          { showSpinner && <span className="carrousel__spinner" /> }
          <ul
            className={ `carrousel__container ${slowAnimation && establishment ? '-slow-animation' : '-hidding-animation'}` }
            style={ containerStyle }
          >
            { Children.map(children, (slide, i) => (
              !slide ? null
                : (
                  <li
                    className={ `carrousel__container__element${i === index ? ' -is-showed' : ''}${i === index - 1 ? ' -is-prev-to-showed' : ''}${i === index + 1 ? ' -is-next-to-showed' : ''}` }
                    style={ { width: `${this.getSlideWidthPercent()}%` } }
                  >
                    { slide }
                  </li>
                )
            ))}
          </ul>
        </div>
        <Dots
          active={ Math.round(index) }
          length={ establishment ? establishment.numImages : null }
          margin={ 0 }
          visible={ 4 }
        />
        <span className="carrousel__number">
          { `${Math.round(index + 1)}  / ${numberOfSlides}` }
        </span>
      </div>
    );
  }
}

Carrousel.defaultProps = {
  arrowsComponent: null,
  className: '',
  currentSlide: 0,
  establishment: null,
  handleArrowsClick: () => {},
  handleSlideChange: () => {},
  isSwipeEnabled: true,
  showArrows: false,
  showSpinner: false,
};

Carrousel.propTypes = {
  arrowsComponent: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  currentSlide: PropTypes.number,
  establishment: PropTypes.shape(),
  handleArrowsClick: PropTypes.func,
  handleSlideChange: PropTypes.func,
  isSwipeEnabled: PropTypes.bool,
  showArrows: PropTypes.bool,
  showSpinner: PropTypes.bool,
};
